import { CustomProductListState } from "@iewc/Store/State/ProductList/ProductListState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: CustomProductListState = {
    page: 1,
    pageSize: 10,
    scrollPosition: 0,
    isLoading: false,
    products: [],
};

const customProductListReducer = {
    "Custom/ProductList/InfiniteScrollLoading": (draft: Draft<CustomProductListState>) => ({
        ...draft,
        isLoading: true,
    }),

    "Custom/ProductList/InfiniteScrollLoaded": (draft: Draft<CustomProductListState>) => ({
        ...draft,
        isLoading: false,
    }),

    "Custom/ProductList/SetPage": (draft: Draft<CustomProductListState>, action: { page: number }) => ({
        ...draft,
        page: action.page,
    }),

    // we need to append the new products to the existing products
    "Custom/ProductList/SetProducts": (draft: Draft<CustomProductListState>, action: { products: ProductModel[] }) => ({
        ...draft,
        products: [...(draft.products ?? []), ...action.products],
    }),

    "Custom/ProductList/ResetInfiniteScrollPage": (draft: Draft<CustomProductListState>) => ({
        ...draft,
        page: 1,
        products: [],
    }),

    "Custom/ProductList/InfiniteScroll": (
        draft: Draft<CustomProductListState>,
        action: {
            page: number;
            pageSize: number;
            scrollPosition: number;
        },
    ) => {
        draft.page = action.page;
        draft.pageSize = action.pageSize ?? 10;
        draft.scrollPosition = action.scrollPosition;
    },

    "Custom/ProductList/SetFilterLoading": (
        draft: Draft<CustomProductListState>,
        action: {
            isLoadingFilter: boolean;
        },
    ) => {
        draft.isLoadingFilter = action.isLoadingFilter;
    },
};

export default createTypedReducerWithImmer(initialState, customProductListReducer);
